import classNames from 'classnames';
import { isAfter } from 'date-fns/isAfter';
import { isBefore } from 'date-fns/isBefore';
import { parseISO } from 'date-fns/parseISO';
import { FormattedDate, FormattedMessage } from 'react-intl';

import ContestForm from '../forms/ContestForm';
import FormDescription from '../typography/FormDescription';

import styles from '../../styles/blocks/contest-block.module.css';

interface ContestBlockProps {
    contest: Contest;
    form?: Form;
    className?: string | null;
}

const ContestBlock = ({ contest, form = null, className = null }: ContestBlockProps) => {
    const { title = null, startAt = null, endAt = null } = contest;
    const startAtDate = startAt !== null ? parseISO(startAt) : null;
    const endAtDate = endAt !== null ? parseISO(endAt) : null;
    const isComing = startAtDate !== null && isBefore(new Date(), startAtDate);
    const isEnded = endAtDate !== null && isAfter(new Date(), endAtDate);
    const isStarted = !isComing && !isEnded;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                {isStarted ? <ContestForm contest={contest} form={form} withEmail /> : null}
                {isComing || isEnded ? (
                    <FormDescription className={styles.wait}>
                        {isComing ? (
                            <FormattedMessage
                                defaultMessage="Le {title} commence le <strong>{date}</strong>."
                                description="Contest wait message"
                                values={{
                                    title: (title || 'concours')
                                        .replace(/^(Concours)?/i, 'concours ')
                                        .replace(/\s+$/, ''),
                                    date: (
                                        <FormattedDate
                                            value={startAtDate}
                                            weekday="long"
                                            day="numeric"
                                            month="long"
                                        />
                                    ),
                                }}
                            />
                        ) : (
                            <FormattedMessage
                                defaultMessage="Le {title} est terminé depuis le {date}."
                                description="Contest wait message"
                                values={{
                                    title: title || 'concours',
                                    date: (
                                        <FormattedDate
                                            value={endAtDate}
                                            weekday="long"
                                            day="numeric"
                                            month="long"
                                        />
                                    ),
                                }}
                            />
                        )}
                    </FormDescription>
                ) : null}
            </div>
        </div>
    );
};

export default ContestBlock;
